/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

import styled from '@emotion/styled'
import { Button as MuiButton, Grid2 as Grid, Typography } from '@mui/material'
import { spacing, SpacingProps } from '@mui/system'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

import useT from '@/i18n/useT'

interface ButtonProps extends SpacingProps {
  component?: React.ElementType
  to?: string
  target?: string
}

const Button = styled(MuiButton)<ButtonProps>(spacing)

const Wrapper = styled.div`
  text-align: center;
`

export const NotAuthorized = () => {
  const { t } = useT()

  return (
    <Wrapper>
      <Helmet title={t('notAuthorized.helmet', 'Not Authorized')} />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        {t('notAuthorized.title', 'Not Authorized')}
      </Typography>
      <Typography
        component="h2"
        variant="subtitle1"
        align="center"
        gutterBottom
      >
        {t('notAuthorized.subtitle', 'You do not have access to this page.')}
      </Typography>
      <Grid container spacing={2} direction={'column'}>
        <Button
          component={Link}
          to="/stats"
          variant="contained"
          color="primary"
          fullWidth={false}
          mt={2}
        >
          {t('notAuthorized.actions.returnToDashboard', 'Return to dashboard')}
        </Button>
        <Button
          component={Link}
          to="/login"
          variant="outlined"
          color="primary"
          fullWidth={false}
          mt={2}
        >
          {t('notAuthorized.actions.signIn', 'Sign in')}
        </Button>
      </Grid>
    </Wrapper>
  )
}
